export enum UserType {
    SystemAdmin = "SystemAdmin",
    InstitutionAdmin = "InstitutionAdmin",
    InstitutionManager = "InstitutionManager",
    StoreAdmin = "StoreAdmin",
    StoreManager = "StoreManager",
    StoreStaff = "StoreStaff",
    Accountant = "Accountant",
    SalesRep = "SalesRep",
    SaaSOperator = "SaaSOperator",
    User = "User"
}

